import { createClient } from '@supabase/supabase-js';

// --- AUTO-GENERATED TYPES FROM SUPABASE MCP ---
export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[];

export type Database = {
  public: {
    // Catch-all permissive table shape. The previous version of this file
    // hand-declared strict shapes for `activity_logs` + `installer_partners`
    // only, which caused every other table operation to collapse to `never`
    // (and broke ~377 call sites once cache invalidated). Switching to a
    // single index signature keeps PostgREST happy and gives every consumer
    // an `any`-typed row. The full strict generated Database type lives in
    // `@/types/supabase` — migrate services to it one at a time when
    // ready, but importing it everywhere at once surfaced ~4000 latent
    // strict-shape conflicts that aren't ready to be fixed.
    /* eslint-disable @typescript-eslint/no-explicit-any */
    Tables: {
      [key: string]: {
        Row: Record<string, any>;
        Insert: Record<string, any>;
        Update: Record<string, any>;
        Relationships: any[];
      };
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Views: { [key: string]: { Row: Record<string, any>; Relationships: any[] } };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Functions: { [key: string]: { Args: Record<string, any>; Returns: any } };
    Enums: { [key: string]: string };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    CompositeTypes: { [key: string]: any };
  };
};
/* eslint-enable @typescript-eslint/no-explicit-any */

// --- END AUTO-GENERATED TYPES ---

// Import the supabase client from supabaseClient.ts instead of creating a new one
import { supabase as supabaseClient } from './supabaseClient';

// Export the typed supabase client
export const supabase = supabaseClient as unknown as ReturnType<typeof createClient<Database>>;
